/**
 * @fileoverview > handler for the "/engagement/link_aliases/update_links" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLinkAliasesUpdateLinksCacheKeys } from "./constants";
import type { PostLinkAliasesUpdateLinksProps } from "./types";

export const postLinkAliasLinks = reactQueryMutationAdapter(
  engagementLinkAliasesUpdateLinksCacheKeys,
  (props: PostLinkAliasesUpdateLinksProps): Promise<void> => {
    return fetch("/engagement/link_aliases/update_links", "POST", props);
  }
);
